// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayer":"iwrWoGmi8ivj1c0C6PiBT"};